<div class="flex flex-col justify-center items-center mt-4" *transloco="let t; read: 'user.profile'">
  <h2 class="text-color-sun-yellow">
    {{t('title')}}
  </h2>
  <psc-loader *ngIf="loading"></psc-loader>
  <form class="flex flex-col px-4 w-full md:w-1/2 xl:w-1/4 md:shrink-0" [formGroup]="formGroup"
        (keydown.enter)="onSubmit()"
        *ngIf="this.formGroup">

    <psc-input [label]="t('email')" formControlName="email" [readonly]="true"></psc-input>
    <!--  t(first_name, last_name, company, address, mobile_phone)  -->
    <ng-container *ngFor="let field of profileFields">
      <psc-input [label]="t(field.label)"
                 formControlName="{{ field.name }}"></psc-input>
    </ng-container>

    <psc-button [label]="t('update-profile')"
                (buttonClicked)="onSubmit()"
                [disabled]="!formGroup.valid"
                class="my-5"
                type="primary-blue-2"></psc-button>
  </form>
</div>
